export const RETURNS_INFO_LINK = '/help/en/online-help-system.page#help-returns';

export const returnableKeys: string[] = [
  'lainfha.5.gif',
  'lainfha17.gif',
  'lainfha18.gif',
  'lainfha19.gif',
  'lainfha2.gif',
  'lainfha20.gif',
  'lainfha21.gif',
  'lainfha3.gif',
  'lainfha5.gif',
  'lainfha6.gif',
  'lainfha7.gif',
  'lainfha8.gif',
];

const nonReturnableList: Record<string, string> = {
  'nonReturnable.lainfha.5.gif.beforeLink':
    'Under our Approval Guarantee, this item is non-returnable once it has been removed from its packaging due to reasons of health and hygiene. Your statutory rights are not affected. See',
  'nonReturnable.lainfha.5.gif.afterLink': 'in our Help pages for more information.',
  'nonReturnable.lainfha.5.gif.link.text': 'Returns section',
  'nonReturnable.lainfha.5.gif.link.href': RETURNS_INFO_LINK,

  'nonReturnable.lainfha17.gif.beforeLink':
    'Perishable items are non-returnable under our Approval Guarantee. Your statutory rights are not affected. See',
  'nonReturnable.lainfha17.gif.afterLink': 'in our Help pages for more information.',
  'nonReturnable.lainfha17.gif.link.text': 'Returns section',
  'nonReturnable.lainfha17.gif.link.href': RETURNS_INFO_LINK,

  'nonReturnable.lainfha18.gif.beforeLink':
    'Non returnable under our Approval Guarantee, once assembled. Your statutory rights are not affected. See',
  'nonReturnable.lainfha18.gif.afterLink': 'in our Help pages for more information.',
  'nonReturnable.lainfha18.gif.link.text': 'Returns section',
  'nonReturnable.lainfha18.gif.link.href': RETURNS_INFO_LINK,

  'nonReturnable.lainfha19.gif.beforeLink':
    'For reasons of hygiene, pierced jewellery is non returnable once the seal is broken or removed under our approval guarantee. See',
  'nonReturnable.lainfha19.gif.afterLink': 'in our Help pages for more information.',
  'nonReturnable.lainfha19.gif.link.text': 'Returns section',
  'nonReturnable.lainfha19.gif.link.href': RETURNS_INFO_LINK,

  'nonReturnable.lainfha2.gif.beforeLink':
    'Non returnable under our Approval Guarantee, once assembled. Your statutory rights are not affected. See',
  'nonReturnable.lainfha2.gif.afterLink': 'in our Help pages for more information.',
  'nonReturnable.lainfha2.gif.link.text': 'Returns section',
  'nonReturnable.lainfha2.gif.link.href': RETURNS_INFO_LINK,

  'nonReturnable.lainfha20.gif.beforeLink':
    '21 day Approval Guarantee. For reasons of hygiene, pierced jewellery is non returnable once the seal is broken or removed under our approval guarantee. See',
  'nonReturnable.lainfha20.gif.afterLink': 'in our Help pages for more information.',
  'nonReturnable.lainfha20.gif.link.text': 'Returns section',
  'nonReturnable.lainfha20.gif.link.href': RETURNS_INFO_LINK,

  'nonReturnable.lainfha21.gif.beforeLink':
    'Under our Approval Guarantee, this item is non-returnable once it has been removed from its protective cover due to reasons of health and hygiene. Your statutory rights are not affected. See',
  'nonReturnable.lainfha21.gif.afterLink': 'in our Help pages for more information.',
  'nonReturnable.lainfha21.gif.link.text': 'Returns section',
  'nonReturnable.lainfha21.gif.link.href': RETURNS_INFO_LINK,

  'nonReturnable.lainfha3.gif.beforeLink':
    'Non returnable under our Approval Guarantee, once installed or connected. Your statutory rights are not affected. See',
  'nonReturnable.lainfha3.gif.afterLink': 'in our Help pages for more information.',
  'nonReturnable.lainfha3.gif.link.text': 'Returns section',
  'nonReturnable.lainfha3.gif.link.href': RETURNS_INFO_LINK,

  'nonReturnable.lainfha5.gif.beforeLink':
    '28 day Approval Guarantee. Non returnable under our Approval Guarantee, for reasons of health & hygiene. Your statutory rights are not affected. See',
  'nonReturnable.lainfha5.gif.afterLink': 'in our Help pages for more information.',
  'nonReturnable.lainfha5.gif.link.text': 'Returns section',
  'nonReturnable.lainfha5.gif.link.href': RETURNS_INFO_LINK,

  'nonReturnable.lainfha6.gif.beforeLink':
    '21 day Approval Guarantee. We will replace or refund most items provided they are returned complete, unused and in the original packaging, with any appropriate security tags intact, within 21 days of receipt. See',
  'nonReturnable.lainfha6.gif.afterLink': 'in our Help pages for more information.',
  'nonReturnable.lainfha6.gif.link.text': 'Returns section',
  'nonReturnable.lainfha6.gif.link.href': RETURNS_INFO_LINK,

  'nonReturnable.lainfha7.gif.beforeLink':
    'Personalised items are non-returnable under our Approval Guarantee. Your statutory rights are not affected. See',
  'nonReturnable.lainfha7.gif.afterLink': 'in our Help pages for more information.',
  'nonReturnable.lainfha7.gif.link.text': 'Returns section',
  'nonReturnable.lainfha7.gif.link.href': RETURNS_INFO_LINK,

  'nonReturnable.lainfha8.gif.beforeLink':
    'Once seal is broken or removed, these items are non-returnable under our Approval Guarantee. Your statutory rights are not affected. See',
  'nonReturnable.lainfha8.gif.afterLink': 'in our Help pages for more information.',
  'nonReturnable.lainfha8.gif.link.text': 'Returns section',
  'nonReturnable.lainfha8.gif.link.href': RETURNS_INFO_LINK,
};

export default nonReturnableList;
